import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './index.module.scss';
import { ImageBottomTextTop, ImageCenterTextCenter, ImageCenterTextOverlayLeft, ImageLeftTextRight, ImageRightTextLeft, ImageTopTextBottom } from './Layouts';
import { jsx as _jsx } from "react/jsx-runtime";
var HERO_LAYOUT = {
  // 16x9 desktop layouts
  CENTER_BOTTOM_LEFT: ImageCenterTextCenter,
  CENTER_BOTTOM_RIGHT: ImageCenterTextCenter,
  CENTER_CENTER: ImageCenterTextCenter,
  CENTER_TOP_LEFT: ImageCenterTextCenter,
  CENTER_TOP_RIGHT: ImageCenterTextCenter,
  // 4x3 desktop layouts
  LEFT_RIGHT: ImageLeftTextRight,
  RIGHT_LEFT: ImageRightTextLeft,
  // 4x3 mobile layout
  BOTTOM_TOP: ImageBottomTextTop,
  TOP_BOTTOM: ImageTopTextBottom,
  CENTER_BOTTOM_LEFT_4X3: ImageCenterTextOverlayLeft,
  CENTER_TOP_LEFT_4X3: ImageCenterTextOverlayLeft,
  // 1x1 mobile layouts
  TOP_BOTTOM_1X1: ImageTopTextBottom,
  BOTTOM_TOP_1X1: ImageBottomTextTop,
  CENTER_BOTTOM_LEFT_1X1: ImageCenterTextOverlayLeft,
  CENTER_TOP_LEFT_1X1: ImageCenterTextOverlayLeft
};

var Block = function Block(_ref) {
  var block = _ref.block,
      lazyload = _ref.lazyload,
      removeOuterMargins = _ref.removeOuterMargins;
  var blockType = block.blockType,
      layout = block.layout,
      rawHtml = block.rawHtml;
  var deviceSizeType = blockType.toLowerCase();
  var rootClass = cc([css.root, css[deviceSizeType]]);

  if (rawHtml) {
    return /*#__PURE__*/_jsx("div", {
      className: rootClass,
      dangerouslySetInnerHTML: {
        __html: rawHtml
      }
    });
  }

  var Layout = HERO_LAYOUT[layout];
  return Layout && /*#__PURE__*/_jsx("section", {
    className: rootClass,
    children: /*#__PURE__*/_jsx(Layout, {
      block: block,
      lazyload: lazyload,
      removeOuterMargins: removeOuterMargins
    })
  });
};

Block.propTypes = {
  block: PropTypes.shape({
    blockType: PropTypes.string.isRequired,
    buttonType: PropTypes.string,
    cta: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
    layout: PropTypes.string,
    rawHtml: PropTypes.string,
    subtitle: PropTypes.string,
    subtitleColor: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleColor: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  lazyload: PropTypes.bool.isRequired,
  removeOuterMargins: PropTypes.bool.isRequired
};

var HeroHomepage = function HeroHomepage(_ref2) {
  var blocks = _ref2.blocks,
      lazyload = _ref2.lazyload,
      removeOuterMargins = _ref2.removeOuterMargins;
  return blocks.edges.length > 0 && blocks.edges.map(function (_ref3) {
    var node = _ref3.node;
    return /*#__PURE__*/_jsx(Block, {
      block: node,
      lazyload: lazyload,
      removeOuterMargins: removeOuterMargins
    }, node.id);
  });
};

HeroHomepage.defaultProps = {
  blocks: {
    edges: []
  },
  lazyload: true,
  removeOuterMargins: false
};
HeroHomepage.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  lazyload: PropTypes.bool.isRequired,
  removeOuterMargins: PropTypes.bool
};
export default HeroHomepage;